import { render, staticRenderFns } from "./SummaryGraph.vue?vue&type=template&id=687dc97d"
import script from "./SummaryGraph.vue?vue&type=script&lang=js"
export * from "./SummaryGraph.vue?vue&type=script&lang=js"
import style0 from "./SummaryGraph.vue?vue&type=style&index=0&id=687dc97d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports